import { SeverityLevelContact } from './severity-level-contacts';

export const MSC_SEVERITY_LEVEL_CONTACTS: SeverityLevelContact[] = [
  {
    severity: '1st Level',
    contacts: [
      {
        name: 'MSC Engineer On Duty',
        phones: [{ number: '+1 855 661 5571', type: 'OFF' }],
        email: 'CBNmsc@comcast.com',
      },
      {
        name: 'NOC Engineer On Duty',
        phones: [{ number: '+1 866 892 0915', type: 'OFF' }],
        email: 'CBNnoc@comcast.com',
      },
    ],
  },
  {
    severity: '2nd Level',
    link: '2nd-level',
    contacts: [
      {
        name: 'Patti Annis',
        title: 'Sr. Manager, MSC - Managed Services Center',
        phones: [
          { number: '+1 773 661 5571', type: 'OFF' },
          { number: '+1 773 895 2884', type: 'CEL' },
        ],
        email: 'Patricia_Annis@comcast.com',
      },
      {
        name: 'Jason Wiley',
        title: 'Sr. Manager, Escalations Management',
        phones: [
          { number: '+1 312 253 4368', type: 'OFF' },
          { number: '+1 312 656 3481', type: 'CEL' },
        ],
        email: 'Jason_Wiley@comcast.com',
      },
    ],
  },
  {
    severity: '3rd Level',
    link: '3rd-level',
    contacts: [
      {
        name: 'Lawrence Edmond',
        title: 'VP of Engineering',
        phones: [
          { number: '+1 773 364 3189', type: 'OFF' },
          { number: '+1 219 798 6414', type: 'CEL' },
        ],
        email: 'Lawrence_Edmond@comcast.com',
      },
    ],
  },
  {
    severity: '4th Level',
    link: '4th-level',
    contacts: [
      {
        name: 'Chris Lawler',
        title: 'Vice President, Business Operations & Support',
        phones: [{ number: '+1 215 638 6524', type: 'OFF' }],
        email: 'chris_lawler@cable.comcast.com',
      },
    ],
  },
];
